"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepJobSourceType = void 0;
exports.PrepJobSourceType = {
    SHIPPING_PLAN: "SHIPPING_PLAN",
    WHOLESALE_SHIPMENT: "WHOLESALE_SHIPMENT",
    EXTERNAL_TASK: "EXTERNAL_TASK",
};
//# sourceMappingURL=prep-job-source-type.js.map